
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busrentalsforschooltripinpune() {



    const cardData =
    {
        keyword: 'Bus Rentals For School Trips in Pune',
        heading: 'Amruta Travels: Bus Rentals For School Trips in Pune',
        headingDescription: 'Amruta Travels offers Bus Rentals for School Trips in Pune, providing safe, reliable, and comfortable transportation solutions tailored for educational outings. Whether it is a local field trip, an outstation educational tour, or a school picnic, our well-maintained fleet ensures a smooth and enjoyable journey for students and staff alike. With experienced drivers, punctual service, competitive pricing, and 24/7 support, we make school travel simple and stress-free. Choose from our range of buses, including 32-seater, 35-seater, 45-seater, and 50-seater options, to suit your group size. Book your school trip bus with Amruta Travels and ensure a memorable and comfortable experience for all!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],

      "services": [
    {
      "name": "Bus Hire for School Trips",
      "description": "Amruta Travels provides reliable bus hire services for school trips in Pune. Our buses are perfect for field trips, educational tours, and recreational outings, ensuring a safe, comfortable, and enjoyable experience for students and staff alike."
    },
    {
      "name": "Bus Rentals for School Trips",
      "description": "For school trips in Pune, Amruta Travels offers affordable bus rentals with fully equipped buses and experienced drivers. Whether you're planning a day trip or an overnight journey, we ensure your students have a pleasant, safe, and hassle-free experience."
    },
    {
      "name": "School Buses for Field Trips Near Me",
      "description": "If you're looking for school buses for field trips near Pune, Amruta Travels provides a range of options for short or long-distance travel. Our buses are perfect for educational trips, with all the necessary amenities for a comfortable ride."
    },
    {
      "name": "Bus Companies for School Field Trips",
      "description": "Amruta Travels is one of the leading bus companies for school field trips in Pune. We offer buses equipped with modern facilities, ensuring a comfortable and safe journey for students and teachers on educational excursions."
    },
    {
      "name": "Bus Rentals for School Trips Pune",
      "description": "Amruta Travels offers bus rentals for school trips in Pune, with a fleet of well-maintained buses available for local and outstation trips. Our buses are spacious, clean, and designed for comfort, making school outings a breeze."
    },
    {
      "name": "Bus Rent for Picnic in Pune",
      "description": "Planning a picnic in Pune? Amruta Travels offers affordable bus rental options for school picnics, family get-togethers, or corporate outings. Our buses are comfortable, spacious, and equipped to meet your travel needs."
    },
    {
      "name": "Tourist Bus Rent Per Day",
      "description": "Amruta Travels offers tourist bus rentals per day, ideal for group excursions, school trips, or family tours in and around Pune. Enjoy a relaxed, comfortable, and safe journey in our well-maintained fleet of tourist buses."
    },
    {
      "name": "Mini Bus Rent in Pune for Picnic",
      "description": "For smaller groups heading for a picnic in Pune, Amruta Travels offers mini bus rentals that are perfect for family or school picnics. Our mini buses are compact, comfortable, and perfect for short-distance travel."
    },
    {
      "name": "Bus for Rent in Pune School Picnic",
      "description": "If you need a bus for a school picnic in Pune, Amruta Travels offers a variety of rental options. Our buses are designed for school groups, providing ample space, comfort, and safety for students and teachers alike."
    },
    {
      "name": "Buses for College Picnic in Pune",
      "description": "For college picnics or excursions in Pune, Amruta Travels offers buses that can accommodate large groups of students. Our buses ensure comfort, safety, and reliability for all your group outing needs."
    },
    {
      "name": "Rental Buses for Trips in Pune",
      "description": "Amruta Travels offers rental buses for all types of trips in Pune, including school and college outings, family picnics, and corporate events. Our buses are spacious, clean, and well-equipped to make your journey comfortable."
    },
    {
      "name": "50 Seater Bus on Rent in Pune",
      "description": "Looking for a 50-seater bus on rent in Pune? Amruta Travels offers comfortable and spacious 50-seater buses for school trips, corporate events, and family outings. Our buses are air-conditioned, well-maintained, and equipped with safety features."
    },
    {
      "name": "45 Seater Bus for Rent in Pune",
      "description": "Amruta Travels offers 45-seater buses for rent in Pune, ideal for school trips, college excursions, and group outings. Our buses are clean, comfortable, and equipped with all the necessary amenities for a smooth and enjoyable ride."
    },
    {
      "name": "32 Seater Bus on Rent Pune for School Trip",
      "description": "Amruta Travels offers 32-seater buses on rent for school trips in Pune. Whether it's a short local outing or a long-distance journey, our 32-seater buses ensure a comfortable and safe experience for students and staff."
    },
    {
      "name": "35 Seater Bus on Rent for School Trip",
      "description": "Rent a 35-seater bus from Amruta Travels for your school trip in Pune. Our buses are designed for group travel, offering ample seating, AC comfort, and a reliable, experienced driver for your school's journey."
    },
    {
      "name": "Coach Hire for School Trips",
      "description": "Amruta Travels provides coach hire services for school trips in Pune. Our coaches are perfect for long-distance or overnight trips, ensuring maximum comfort and safety for students and teachers during the journey."
    },
    {
      "name": "Coach Hire for School Trips Near Me",
      "description": "Looking for a coach near you for a school trip? Amruta Travels offers local and outstation coach hire services in Pune, providing a comfortable, spacious, and reliable travel option for educational outings."
    },
    {
      "name": "Sleeper Bus Hire for School Trips",
      "description": "For longer school trips, Amruta Travels offers sleeper bus hire services, ensuring students can rest comfortably while traveling. Our sleeper buses are equipped with cozy sleeping arrangements, ideal for overnight school journeys."
    },
    {
      "name": "Bus Hire for College Trip in Pune",
      "description": "Amruta Travels offers bus hire services for college trips in Pune. Whether it's a picnic, field trip, or excursion, our buses provide comfort and safety for all students, with professional drivers and well-maintained buses."
    }
  ],
  "tableData": [
    ["Bus Hire for School Trips", "Bus Rentals for School Trips"],
    ["School Buses for Field Trips Near Me", "Bus Companies for School Field Trips"],
    ["Bus Rentals for School Trips Pune", "Bus Rent for Picnic in Pune"],
    ["Tourist Bus Rent Per Day", "Mini Bus Rent in Pune for Picnic"],
    ["Bus for Rent in Pune School Picnic", "Buses for College Picnic in Pune"],
    ["Rental Buses for Trips in Pune", "50 Seater Bus on Rent in Pune"],
    ["45 Seater Bus for Rent in Pune", "32 Seater Bus on Rent Pune for School Trip"],
    ["35 Seater Bus on Rent for School Trip", "Coach Hire for School Trips"],
    ["Coach Hire for School Trips Near Me", "Sleeper Bus Hire for School Trips"],
    ["Bus Hire for College Trip in Pune", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Safe and Comfortable Transportation",
    "WhyChoosedescription": "Amruta Travels offers Bus Rentals for School Trips in Pune, ensuring student safety with comfortable seating, seatbelts, and well-maintained buses designed for secure group travel."
  },
  {
    "WhyChooseheading": "Ideal for Educational Tours and Picnics",
    "WhyChoosedescription": "Our buses are perfect for school picnics, educational tours, field trips, and inter-school competitions. We provide reliable, on-time transportation tailored to school requirements."
  },
  {
    "WhyChooseheading": "Verified and Trained Drivers",
    "WhyChoosedescription": "All our drivers are background-checked, professionally trained, and experienced in handling school group transportation with the utmost care and responsibility."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Rates",
    "WhyChoosedescription": "We offer budget-friendly and clearly priced Bus Rentals for School Trips in Pune. There are no hidden charges, helping schools plan trips confidently within budget."
  },
  {
    "WhyChooseheading": "Clean and Child-Friendly Buses",
    "WhyChoosedescription": "Our buses are cleaned daily and undergo routine maintenance to ensure hygiene and safety. We maintain a child-friendly environment for a pleasant journey."
  },
  {
    "WhyChooseheading": "Flexible Scheduling and Pickup Points",
    "WhyChoosedescription": "Whether it's a short local trip or a full-day excursion, we offer flexible scheduling and customized pick-up and drop-off arrangements to suit school timings and locations."
  },
  {
    "WhyChooseheading": "Assistance with Trip Planning",
    "WhyChoosedescription": "We help schools plan routes, stopovers, and travel timing for optimal convenience and safety. Our team ensures that every trip runs smoothly from start to finish."
  },
  {
    "WhyChooseheading": "Easy Booking and Reliable Support",
    "WhyChoosedescription": "Booking Bus Rentals for School Trips in Pune is easy with Amruta Travels. Contact us online, by phone, or visit our office—we’re here to assist with prompt and friendly support."
  }
]

























    }

const faqData = [
  {
    question: 'How can I rent a bus for a school trip in Pune with Amruta Travels?',
    answer: 'Renting a bus for a school trip in Pune with Amruta Travels is easy. You can book through our website, contact our support team, or visit our office. We’ll assist you in selecting the right bus for your group’s travel needs.',
  },
  {
    question: 'What types of buses are available for school trips in Pune?',
    answer: 'We offer a variety of buses for school trips, including 32, 35, 45, and 50 seater options. All our buses are equipped with comfortable seating, air conditioning, and ample luggage space for school bags and other essentials.',
  },
  {
    question: 'Are the buses safe for school trips?',
    answer: 'Yes, safety is our priority. Our buses are regularly maintained, and our drivers are trained to ensure a safe, smooth, and enjoyable trip for students. We also ensure that the buses are equipped with necessary safety features.',
  },
  {
    question: 'Are the buses sanitized before school trips?',
    answer: 'Yes, all our buses are thoroughly sanitized before each trip, ensuring a hygienic and safe environment for students and teachers on the journey.',
  },
  {
    question: 'How much does it cost to rent a bus for a school trip in Pune?',
    answer: 'The rental cost depends on the type of bus, trip duration, and other requirements. Please contact us with your trip details for a custom quote.',
  },
  {
    question: 'Can I request multiple pickup and drop-off locations for the school trip?',
    answer: 'Yes, we can customize the route to include multiple pickup and drop-off points. Just provide us with the details of the locations and we’ll plan the best route for your trip.',
  },
  {
    question: 'Do you provide drivers with the buses for school trips?',
    answer: 'Yes, all our bus rentals for school trips come with experienced, licensed drivers who are trained to ensure safety, punctuality, and a smooth experience for the entire group.',
  },
  {
    question: 'Can the buses be hired for educational tours?',
    answer: 'Yes, our buses are ideal for educational tours. Whether it’s a visit to museums, historical sites, or other learning experiences, we can provide comfortable and reliable transport for your students.',
  },
  {
    question: 'Why choose Amruta Travels for school trip bus rentals in Pune?',
    answer: 'Amruta Travels offers well-maintained buses, professional drivers, and a focus on safety and comfort. We strive to make every school trip enjoyable and stress-free with reliable and punctual service.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Amit Sharma',
    role: 'Principal, Pune School',
    text: 'We hired a 35-seater bus from Amruta Travels for our school’s annual trip. The bus was spacious, well-maintained, and the driver was very responsible. Our students had a great time, and we were very satisfied with the service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Joshi',
    role: 'Teacher, Pune School',
    text: 'Amruta Travels provided a 45-seater bus for our school’s educational tour. The journey was comfortable, and the driver was experienced and courteous. The trip went smoothly, and we would definitely book with them again.',
    rating: 5,
  },
];





































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Rentals For School Trips in Pune",
  "image": "https://bushireinpune.com/assets/images/bus-rentals-for-school-trips.jpg",
  "description": "Rent buses for school trips in Pune with Amruta Travels. Choose from 32, 35, 45, and 50-seater buses for picnics, field trips, college trips, and more. Comfortable, affordable, and safe transport for students. AC and Non-AC options available for all types of school excursions.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5074"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "40", // Adjust based on per km or flat rate
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-rentals-for-school-trips-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Bus Rentals For School Trips in Pune | College & Picnic Bus Hire | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book buses for school trips in Pune with Amruta Travels. Rent 32, 35, 45, and 50-seater buses for picnics, field trips, and college excursions. Safe, comfortable, and affordable transportation." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/9.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busrentalsforschooltripinpune;